import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@mui/material';
import { Container } from "react-bootstrap";
import { Truck, CreditCard, ShieldLock, ArrowsAngleExpand } from "react-bootstrap-icons";

const brandColor = "#2E0205";

const faqs = [
    {
        q: "¿Manejan pago contra entrega?",
        a: "Pago contra entrega a cuidades seleccionadas, para saber si tu cuidad aplica puedes preguntarle a uno de nuestros asesores."
    },
    {
        q: "¿Cuánto cuesta el envío?",
        a: "Puedes calcularlo directamente en el catálogo, en tu carrito de compra o preguntarle a uno de nuestros asesores por whatsapp."
    },
    {
        q: "¿Dónde están ubicados?",
        a: "Estamos en Bogotá y realizamos envios a todo Colombia."
    },
    {
        q: "¿Dirección exacta?",
        a: "calle 57A #78K-04 sur, Nueva Roma, Kennedy, Bogotá - Cundinamarca. De Lunes a Sábado de 11:00 a.m. a 9:00 p.m."
    },
    {
        q: "¿Por qué confiar en nosotros?",
        a: "Te damos atención personalizada, te enviamos fotos o videos de los productos y hacemos una validación previa del pedido."
    }
];

const PreguntasFrecuentes = () => {
    const [expanded, setExpanded] = useState(null);

    const handleChange = (panel) => {
        setExpanded(expanded === panel ? null : panel);
    };

    return (
        <div className='p-5 color-bg-secundary'>
            {/* HEADER NUEVO */}
            <div className='text-center'>
                <h2 className='color-primary fw-bold'>
                    Centro de Ayuda
                </h2>
                <p className='text-muted fs-6 opacity-1' >
                    Resolvemos tus dudas en segundos
                </p>
            </div>

            <Container>

                {/* BENEFICIOS */}
                <div style={{ marginBottom: "25px" }}>
                    {[{
                        icon: <Truck size={22} />,
                        title: "Envíos Contra entrega",
                        text: "A gran parte de Colombia"
                    }, {
                        icon: <CreditCard size={22} />,
                        title: "Paga como quieras",
                        text: "Múltiples métodos"
                    }, {
                        icon: <ShieldLock size={22} />,
                        title: "Compra segura",
                        text: "Protección total"
                    }].map((item, i) => (
                        <div
                            key={i}
                            style={{
                                background: "#e7e2da",
                                borderRadius: "14px",
                                padding: "14px",
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                boxShadow: "0 3px 10px rgba(0,0,0,0.05)"
                            }}
                        >
                            <div
                                style={{
                                    background: `${brandColor}15`,
                                    color: brandColor,
                                    borderRadius: "10px",
                                    padding: "10px",
                                    marginRight: "12px"
                                }}
                            >
                                {item.icon}
                            </div>

                            <div>
                                <strong className='color-primary' style={{ fontSize: "0.95rem" }}>{item.title}</strong>
                                <p className='text-muted' style={{ margin: 0, fontSize: "0.8rem" }}>
                                    {item.text}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* FAQ */}
                {faqs.map((item, i) => (
                    <Accordion
                        key={i}
                        expanded={expanded === i}
                        onChange={() => handleChange(i)}
                        sx={{
                            mb: 1.5,
                            borderRadius: "14px !important",
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            '&:before': { display: 'none' }
                        }}
                    >
                        <AccordionSummary
                            sx={{
                                background: expanded === i ? brandColor : "#e7e2da",
                                color: expanded === i ? "#e7e2da" : "#2E0205",
                                minHeight: "60px"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "space-between"
                                }}
                            >
                                <Typography sx={{ fontWeight: "600", fontSize: "0.95rem" }}>
                                    {item.q}
                                </Typography>

                                <ArrowsAngleExpand
                                    style={{
                                        transition: "0.3s",
                                        transform: expanded === i ? "rotate(180deg)" : "rotate(0deg)"
                                    }}
                                />
                            </div>
                        </AccordionSummary>

                        <AccordionDetails sx={{ background: "#e7e2da" }}>
                            <Typography sx={{ fontSize: "0.9rem", color: "#555" }}>
                                {item.a}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}

            </Container>
        </div>
    );
};

export default PreguntasFrecuentes;